import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// FIX: Import AuthProvider to make authentication context available to all components.
import { AuthProvider } from './components/context/AuthContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {/* FIX: Wrap the entire application with AuthProvider. */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);